import { render, staticRenderFns } from "./lookimg.vue?vue&type=template&id=4ed7ab6f&"
import script from "./lookimg.vue?vue&type=script&lang=js&"
export * from "./lookimg.vue?vue&type=script&lang=js&"
import style0 from "./lookimg.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports